(ns app.front.view.workspace.add-related
  (:require [app.domain.group.permit-type-config.model :as ptc-model]
            [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.workspace.subs :as ws-subs]
            [app.i18n.model :as i18n-model]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::fetch-workspaces-for-property
  [(rf/path [::state])]
  (fn [{:keys [db]} [_ phase-entity]]
    {:comm/command {:command    :workspace/find
                    :data       {:conditions [{:filter.condition/attribute :property/id
                                               :filter.condition/operator  :equals
                                               :filter.condition/values    (->> phase-entity
                                                                                :entity/parent
                                                                                :workspace/properties
                                                                                (map :property/id)
                                                                                set)}]}
                    :on-success [::fetch-workspaces-for-property.success]}
     :db           (-> db
                       (assoc ::loading? true))}))

(rf/reg-event-db ::fetch-workspaces-for-property.success
  [(rf/path [::state])]
  (fn [db [_ status resp]]
    (if (= 200 status)
      (-> db
          (assoc ::workspaces resp)
          (dissoc ::loading?))
      db)))

(rf/reg-sub ::state :-> ::state)

(rf/reg-sub ::loading?
  :<- [::state]
  :-> ::loading?)

(rf/reg-sub ::related-workspace-ids
  :<- [::ws-subs/workspace]
  (fn [workspace _]
    (->> workspace
         :workspace/related-workspaces
         (concat (:workspace/_related-workspaces workspace))
         (map :workspace/id)
         set)))

(def municipality-eq-tuple
  (juxt :municipality/country :municipality/number :municipality/subdivision))

(rf/reg-sub ::current-workspace-municipality-eq-tuple
  :<- [::ws-subs/workspace-municipality]
  :-> municipality-eq-tuple)

(rf/reg-sub ::workspaces
  :<- [::state]
  :<- [::related-workspace-ids]
  :<- [::ws-subs/workspace-id]
  :<- [::current-workspace-municipality-eq-tuple]
  (fn [[state related-ids current-ws-id municipality-tuple] _]
    (let [invalid-workspace-ids (conj related-ids current-ws-id)]
      (->> state
           ::workspaces
           :results
           (remove (comp invalid-workspace-ids :workspace/id))
           ;; filter out workspaces with matching roll nr but different municipality
           (filter (fn [es-workspace]
                     (= (municipality-eq-tuple es-workspace)
                        municipality-tuple)))
           ;; supplemental workspaces cannot be linked due to guards
           (remove (comp ptc-model/additional-permit-type? :workspace/permit-type))
           (sort-by (juxt :workspace/municipal-case-id :workspace/id))))))

(defn selectable-workspace-list-item [{:keys [workspace checked? on-change lang tr]}]
  (let [workspace-id (:workspace/id workspace)]
    [:li>label.my-4.bg-ui-light-gray.flex.items-center.rounded.p-2.text-ui-night-sky
     [:div.mr-4 (cc/checkbox {:label-text ""
                              :id         workspace-id
                              :checked    checked?
                              :on-change  on-change})]
     [:div.flex.flex-col.w-1-2
      [:div.bold (some-> workspace :workspace/category-names (i18n-model/get-text lang))]
      [:div
       (futil/str-and-desc
         (tr [(:workspace/permit-type workspace)])
         (or (:workspace/municipal-case-id workspace)
             workspace-id))]]
     [:div.ml-4 (:workspace/address workspace)]]))

(defn add-related-modal [{:keys [tr parameters on-change]}]
  (if (<sub [::loading?])
    (cc/loading-spinner {:with-overlay false})
    (let [lang       (<sub [:language])
          workspaces (<sub [::workspaces])]
      (if (seq workspaces)
        [:ul
         (for [workspace workspaces]
           (let [workspace-id (:workspace/id workspace)
                 checked?     (-> parameters :other-workspace-ids (contains? workspace-id))
                 on-change    #(-> parameters
                                   (update :other-workspace-ids
                                           (fnil (if checked? disj conj) #{})
                                           workspace-id)
                                   on-change)]
             ^{:key workspace-id}
             [selectable-workspace-list-item
              (util/mmap workspace checked? on-change lang tr)]))]
        [ui/help (tr [:related-workspace/no-candidates-found])]))))

(defn parameters-valid? [{:keys [other-workspace-ids]}]
  (-> other-workspace-ids empty? not))
